import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ListingOrder } from '@linktivity/ars-neo';
import { buildLocalizedPath } from '@link/share/utils';
import TypesAllIcon from '@link/triplabo/assets/triplabo/types-all.svg?react';
import TypesAttractionIcon from '@link/triplabo/assets/triplabo/types-attraction.svg?react';
import TypesDayIcon from '@link/triplabo/assets/triplabo/types-day.svg?react';
import TypesExperienceIcon from '@link/triplabo/assets/triplabo/types-experience.svg?react';
import TypesShinkansenIcon from '@link/triplabo/assets/triplabo/types-shinkansen.svg?react';
import TypesTrainIcon from '@link/triplabo/assets/triplabo/types-train.svg?react';
import styles from './searchType.module.css';

const SORT = ListingOrder.ListingOrderPriority;

/** Static category links. No state, so this renders identically server-side. */
export default function SearchType({ locale }: { locale: string }) {
  const { t } = useTranslation();

  const searchTypes = [
    {
      value: 'TRANSPORT',
      label: t('triplabo.searchType.transport'),
      icon: <TypesTrainIcon className={styles.searchTypeIcon} />,
      path: `activity?category=TRANSPORT&sort=${SORT}`
    },
    {
      value: 'ATTRACTION',
      label: t('triplabo.searchType.attraction'),
      icon: <TypesAttractionIcon className={styles.searchTypeIcon} />,
      path: `activity?category=ATTRACTION&sort=${SORT}`
    },
    {
      value: 'EXPERIENCE',
      label: t('triplabo.searchType.experience'),
      icon: <TypesExperienceIcon className={styles.searchTypeIcon} />,
      path: `activity?category=EXPERIENCE&sort=${SORT}`
    },
    {
      value: 'SHINKANSEN',
      label: t('triplabo.searchType.shinkansen'),
      icon: <TypesShinkansenIcon className={styles.searchTypeIcon} />,
      path: 'shinkansen'
    },
    {
      value: 'DAY',
      label: t('triplabo.searchType.day'),
      icon: <TypesDayIcon className={styles.searchTypeIcon} />,
      path: `activity?category=DAY&sort=${SORT}`
    },
    {
      value: 'ALL',
      label: t('triplabo.searchType.all'),
      icon: <TypesAllIcon className={styles.searchTypeIcon} />,
      path: `activity?search=&sort=${SORT}`
    }
  ];

  return (
    <div className={styles.searchTypes}>
      {searchTypes.map(searchType => (
        <Link
          className={styles.searchType}
          key={searchType.value}
          to={buildLocalizedPath(searchType.path, locale)}
        >
          {searchType.icon}
          {searchType.label}
        </Link>
      ))}
    </div>
  );
}
